<template>
  <i
    :class="classLocal"
    class="mps"
  />
</template>

<script>
/**
 * @module VIcon
 */
export default {
  name: 'VIcon',
  props: {
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    even: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classLocal () {
      return {
        'mps-fw': this.even,
        [`mps-${this.size}`]: this.size,
        [`mps-${this.type}`]: true
      }
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
